import React, { useEffect } from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { useDispatch } from 'react-redux';
import { fetchUserModule } from './slices/thunks';
import { getAuthUser } from './helpers/utils';
import i18n from './i18n';
import { ToastContainer } from 'react-toastify';

// Activating fake backend
fakeBackend();

function App() {
  const dispatch = useDispatch();
  const {user} = getAuthUser();
  
  useEffect(() => {
    if (user && user.ID) {
      dispatch(fetchUserModule());
    }
  }, []);  
  
  return (
    <React.Fragment>
      <ToastContainer
        autoClose={2000}
        limit={1}
        position={i18n.dir() === 'rtl' ? "top-left" : "top-right"}
        rtl={i18n.dir() === 'rtl'}
      />
      <Route />
    </React.Fragment>
  );
}

export default App;
